import { useEffect } from 'react'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
  }
}

const SCRIPT_ID = 'meta-pixel-script'

/**
 * Instala el Meta Pixel y dispara el evento PageView una sola vez.
 */
export function useMetaPixel(pixelId: string): void {
  useEffect(() => {
    if (!pixelId || typeof window === 'undefined') return

    if (!window.fbq) {
      const fbq: Window['fbq'] = function (...args: unknown[]) {
        if (fbq && fbq.callMethod) {
          fbq.callMethod.apply(fbq, args)
        } else if (fbq && fbq.queue) {
          fbq.queue.push(args)
        }
      } as Window['fbq']

      if (fbq) {
        fbq.queue = []
        fbq.loaded = true
        fbq.version = '2.0'
        fbq.push = fbq
      }

      window.fbq = fbq
      window._fbq = fbq
    }

    if (!document.getElementById(SCRIPT_ID)) {
      const script = document.createElement('script')
      script.id = SCRIPT_ID
      script.async = true
      script.src = 'https://connect.facebook.net/en_US/fbevents.js'
      document.head.appendChild(script)
    }

    window.fbq?.('init', pixelId)
    window.fbq?.('track', 'PageView')

    if (!document.getElementById(`${SCRIPT_ID}-noscript`)) {
      const noscript = document.createElement('noscript')
      noscript.id = `${SCRIPT_ID}-noscript`
      noscript.innerHTML = `<img height="1" width="1" style="display:none" alt="" src="https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1" />`
      document.body.appendChild(noscript)
    }
  }, [pixelId])
}
